
import React, { memo } from "react";
import { cn } from "@/lib/utils";
import {
  NavigationMenu,
  NavigationMenuList,
  NavigationMenuItem,
} from "@/components/ui/navigation-menu";
import { Button } from "@/components/ui/button";
import { Library, BookOpen, User } from "lucide-react";
import { ProtectedNavLinks } from "./ProtectedNavLinks";

interface DesktopNavMenuProps {
  isActive: (path: string) => boolean;
  handleNavigate: (path: string) => (e: React.MouseEvent) => void;
  showProtectedLinks: boolean;
}

const DesktopNavMenuComponent = ({
  isActive,
  handleNavigate,
  showProtectedLinks
}: DesktopNavMenuProps) => {
  return (
    <NavigationMenu>
      <NavigationMenuList>
        <NavigationMenuItem>
          <Button
            variant="ghost"
            className={cn(
              "flex items-center gap-2 text-yarn-slate font-medium hover:text-primary hover:bg-white/40",
              isActive('/library') && "bg-white/50 text-primary"
            )}
            onClick={handleNavigate("/library")}
          >
            <Library className="h-4 w-4" />
            Library
          </Button>
        </NavigationMenuItem>

        {showProtectedLinks ? (
          <ProtectedNavLinks
            isActive={isActive}
            handleNavigate={handleNavigate}
          />
        ) : (
          <>
            <NavigationMenuItem>
              <Button
                variant="ghost"
                className={cn(
                  "flex items-center gap-2 text-yarn-slate font-medium hover:text-primary hover:bg-white/40",
                  isActive('/blog') && "bg-white/50 text-primary"
                )}
                onClick={handleNavigate("/blog")}
              >
                <BookOpen className="h-4 w-4" />
                Blog
              </Button>
            </NavigationMenuItem>
            <NavigationMenuItem>
              <Button
                variant="ghost"
                className={cn(
                  "flex items-center gap-2 text-yarn-slate font-medium hover:text-primary hover:bg-white/40",
                  isActive('/about') && "bg-white/50 text-primary"
                )}
                onClick={handleNavigate("/about")}
              >
                <User className="h-4 w-4" />
                About
              </Button>
            </NavigationMenuItem>
          </>
        )}
      </NavigationMenuList>
    </NavigationMenu>
  );
};

DesktopNavMenuComponent.displayName = 'DesktopNavMenu';

export const DesktopNavMenu = memo(DesktopNavMenuComponent);
